export default __webpack_public_path__ + "static/media/distanstolkning7.f931fc60.png";